import { render, staticRenderFns } from "./Legislacoes.vue?vue&type=template&id=5cf0a0bf&scoped=true&"
import script from "./Legislacoes.vue?vue&type=script&lang=js&"
export * from "./Legislacoes.vue?vue&type=script&lang=js&"
import style0 from "./Legislacoes.vue?vue&type=style&index=0&id=5cf0a0bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0a0bf",
  null
  
)

export default component.exports